<template>
  <div
    class="sticky-bottom"
    :style="{
      bottom: `${isFilterStatus ? 0 : heightColumnWeeklyProps}px`
    }"
  >
    <!-- bottom: `${heightColumnWeekly * 2}px` -->
    <div class="flex-center">
      <div
        v-for="(daily, index) in itemDaily.total_day"
        :key="`daily-${index}`"
        :style="{
          width: `${widthColumnProps}px`,
          height: `${heightColumnDailyProps}px`
        }"
        :class="{ 'border-right-5': index === 1, 'flex-1': isShrink }"
        class="daily-column flex-center"
      >
        <!-- :class="{ 'border-right-5': index === 1, 'bg-grey-2': index === 8 }" -->
        <div
          v-if="index === 'hide-idx-before-is-13'"
          class="flex-center-vertical is-justify-content-space-between c-w-100 px-2"
          :class="{ 'is-flex-direction-column': isShrink }"
        >
          <div
            class="mr-2 pr-2 flex-1"
            :class="{
              'border-right-1-grey-13': !isShrink
            }"
          >
            <p class="averta-bold white-space-nowrap">
              Baru: {{ daily.first_day_completed || 0 }}/{{ daily.first_day_not_completed || 0 }}
            </p>
          </div>
          <div v-if="isShrink" class="divider-line horizontal"></div>
          <div class="mr-2 pr-2 flex-1">
            <p class="averta-bold white-space-nowrap">
              Lanjutan: {{ daily.existing_day_completed || 0 }}/{{
                daily.existing_day_not_completed || 0
              }}
            </p>
          </div>
        </div>
        <div
          v-else
          class="flex-center ellipsis-content"
          :class="{
            'is-flex-direction-column': itemDaily.today || index === 13 || isShrink
          }"
        >
          <!-- index === 8 | Penawaran Ditolak (dataNavbar) -->
          <div class="averta-bold label-14 is-flex is-align-items-center" :class="{ '': isShrink }">
            <p :class="{ 'label-18': isShrink }">
              {{ isShrink ? 'S' : 'Sudah' }} :
              <span class="color-progress-done">{{ daily.completed }}</span>
            </p>
            <p v-if="isToday" :class="{ 'label-18': isShrink }">
              <span class="color-grey-16 ml-1">|</span> {{ isShrink ? 'B' : 'Belum' }} :
              <span class="color-progress-not-yet">{{ daily.not_completed }}</span>
            </p>
            <div v-if="isToday && showRevisi(index)" class="flex-center">
              <div class="divider-line"></div>
              <p :class="{ 'label-18': isShrink }">
                {{ isShrink ? 'R' : 'Revisi' }} :
                <span class="color-progress-revision">{{ daily.revised }}</span>
              </p>
            </div>
            <!-- <div v-if="isToday" class="divider-line" :class="{ 'horizontal': isShrink }"></div>
            <p v-if="itemDaily.today || index === 13">
              Belum :
              {{ index === 17 ? daily.late : daily.not_completed }}
            </p> -->
          </div>
          <!-- <div v-if="(index === 6 || index === 7)">
            <div v-if="isShrink" class="divider-line horizontal"></div>
            <p class="averta-bold label-14 has-text-centered ml-1">
              <span v-if="!(itemDaily.today || index === 13 || isShrink)" class="label-16">|</span>
              Revisi : {{ daily.revised }}
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TotalDailyWeekly',
  props: {
    widthColumnProps: {
      type: Number
    },
    heightColumnWeeklyProps: {
      type: Number
    },
    heightColumnDailyProps: {
      type: Number
    },
    scaleTableProps: {
      type: Number
    },
    itemDaily: {
      type: Object
    },
    isFilterStatus: {
      type: Boolean
    }
  },
  computed: {
    isShrink () {
      return this.scaleTableProps < 0.6
    },
    isToday () {
      return this.itemDaily.today
    }
  },
  methods: {
    showRevisi (index) {
      return index === 6 || index === 7
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.daily-column {
  border: 1px solid $color-grey-10;
  border-left-width: 0;
  background: $color-purple-4;
  min-width: 0;
}

.daily-column.side {
  border-top-width: 1px;
  border-right-width: 0px;
}

.divider-line {
  width: 2.2px;
  height: 16px;
  background-color: #cbd5e1;
  transition: all 0.3s ease-in-out;
  margin: 0 4px;
}

.divider-line.horizontal {
  width: 125px;
  height: 1px;
  margin: 3px 0;
}
</style>
